<template>
  <div id="app">
    <v-app style="background-color: white">
      <main>
        <router-view />
        <Footer></Footer>

      </main>

    </v-app>


  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  created () {
    // Change default options for ALL charts
    // eslint-disable-next-line no-undef
    Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
      color: '#fff',
      textStrokeColor: '#FF5100',
      textStrokeWidth: 2,
      display: false
    });
  },
  methods: {}
};
</script>

<style>
body,html{
  /*padding: 0!important;*/
  /*margin: 0!important;*/
  overflow-x: hidden;
}
#app {
  font-family: "Kanit", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
